import $ from 'jquery';

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

$(document).ready(function ($) {
    var panel = getUrlVars()["panel"];
    //properly scroll to portfolio section
    if (panel || (window.location.hash).includes("#panel-")) {
        let pos = $('#portfolio').offset().top - 80;
        $('html,body').animate({ scrollTop: pos }, 500);
    }

    $(document).on("click", ".js--portfolio-read-more", function () {
        $(".tabs-panel.is-active #" + $(this).attr("data-id")).toggle();

        if ($(this).hasClass("featured-portfolio-item__link--read-less")) {
            $(this).text('+ read more');
        }
        else {
            $(this).text('read less');
        }
        $(this).toggleClass("featured-portfolio-item__link--read-less");
    });



    window.almComplete = function (alm) {

        let portfolioItems = document.querySelectorAll('.js--portfolio-item');
        let featuredPortfolioItem = document.querySelector('#featured-portfolio-card');

        portfolioItems.forEach((portfolioItem, index) => {
            portfolioItem.addEventListener('click', () => {
                if (portfolioItem.dataset.logoone || portfolioItem.dataset.logotwo) {
                    let logoString = '';
                    if (portfolioItem.dataset.logoone) {
                        logoString += '<img src="' + portfolioItem.dataset.logoone + '" alt="Logo image">'
                        featuredPortfolioItem.classList.add('featured-item-one')
                        featuredPortfolioItem.classList.remove('featured-item-two')
                        featuredPortfolioItem.classList.remove('featured-item-three')
                        featuredPortfolioItem.classList.remove('featured-item-four')
                    }
                    if (portfolioItem.dataset.logotwo) {
                        logoString += '<img src="' + portfolioItem.dataset.logotwo + '" alt="Logo image" class="two">'
                        featuredPortfolioItem.classList.add('featured-item-two')
                        featuredPortfolioItem.classList.remove('featured-item-one')
                        featuredPortfolioItem.classList.remove('featured-item-three')
                        featuredPortfolioItem.classList.remove('featured-item-four')
                    }
                    if (portfolioItem.dataset.logothree) {
                        logoString += '<img src="' + portfolioItem.dataset.logothree + '" alt="Logo image" class="three">'
                        featuredPortfolioItem.classList.add('featured-item-three')
                        featuredPortfolioItem.classList.remove('featured-item-two')
                        featuredPortfolioItem.classList.remove('featured-item-one')
                        featuredPortfolioItem.classList.remove('featured-item-four')
                    }
                    if (portfolioItem.dataset.logofour) {
                        logoString += '<img src="' + portfolioItem.dataset.logofour + '" alt="Logo image" class="four">'
                        featuredPortfolioItem.classList.add('featured-item-four')
                        featuredPortfolioItem.classList.remove('featured-item-two')
                        featuredPortfolioItem.classList.remove('featured-item-three')
                        featuredPortfolioItem.classList.remove('featured-item-one')
                    }
                    document.querySelector('.js--portfolio-logos').innerHTML = logoString;
                } else {
                    document.querySelector('.js--portfolio-logos').innerHTML = '';
                }

                if (portfolioItem.dataset.title) {
                    const titleString = '<h4 class="mb-4 text-primary new-h5 font--hkgrotesk-bold">' + portfolioItem.dataset.title + '</h4>';
                    document.querySelector('.js--portfolio-title').innerHTML = titleString;
                } else {
                    document.querySelector('.js--portfolio-title').innerHTML = '';
                }
                console.log(portfolioItem.dataset);
                if (portfolioItem.dataset.fund) {
                    const fundString = '<p class="mb-0 text-primary text-22 font--hkgrotesk-medium">Fund</p><p class="mb-3 text-primary text-24 font--hkgrotesk-bold leading-31">' + portfolioItem.dataset.fund + '</p>';
                    document.querySelector('.js--portfolio-fund').innerHTML = fundString;
                } else {
                    document.querySelector('.js--portfolio-fund').innerHTML = '';
                }

                if (portfolioItem.dataset.sector) {
                    const sectorString = '<p class="mb-0 text-primary text-22 font--hkgrotesk-medium">Sector</p><p class="mb-3 text-primary text-24 font--hkgrotesk-bold leading-31">' + portfolioItem.dataset.sector + '</p>';
                    document.querySelector('.js--portfolio-sector').innerHTML = sectorString;
                } else {
                    document.querySelector('.js--portfolio-sector').innerHTML = '';
                }

                if (portfolioItem.dataset.type) {
                    const typeString = '<p class="mb-0 text-primary text-22 font--hkgrotesk-medium">Type</p><p class="mb-3 text-primary text-24 font--hkgrotesk-bold leading-31">' + portfolioItem.dataset.type + '</p>';
                    document.querySelector('.js--portfolio-type').innerHTML = typeString;
                } else {
                    document.querySelector('.js--portfolio-type').innerHTML = '';
                }

                if (portfolioItem.dataset.address) {
                    const addressString = '<p class="mb-0 text-primary text-22 font--hkgrotesk-medium">Geography</p><p class="mb-3 text-primary text-24 font--hkgrotesk-bold leading-31">' + portfolioItem.dataset.address + '</p>';
                    document.querySelector('.js--portfolio-address').innerHTML = addressString;
                } else {
                    document.querySelector('.js--portfolio-address').innerHTML = '';
                }

                if (portfolioItem.dataset.summary) {
                    const summaryString = '<div class="mb-14 leading-tight text-primary text-22 font--hkgrotesk-regular portfolio-list__featured-card-summary"><?= $portfolio_item_summary?>' + JSON.parse(portfolioItem.dataset.summary) + '</div>';
                    document.querySelector('.js--portfolio-summary').innerHTML = summaryString;
                } else {
                    document.querySelector('.js--portfolio-summary').innerHTML = '';
                }
                
                // if (portfolioItem.dataset.link) {
                //     document.querySelector('.js--portfolio-link').href = portfolioItem.dataset.link;
                // } else {
                //     document.querySelector('.js--portfolio-link').href = '';
                // }

                if (portfolioItem.dataset.amount) {
                    const amountString = '<p class="mb-0 text-primary text-22 font--hkgrotesk-medium">Amount</p><p class="mb-6 text-primary text-24 font--hkgrotesk-bold">$' + portfolioItem.dataset.amount + '</p>';
                    document.querySelector('.js--portfolio-amount').innerHTML = amountString;
                } else {
                    document.querySelector('.js--portfolio-amount').innerHTML = '';
                }

                document.getElementById("portfolioView").scrollIntoView();

            })
        })


        // var filterToggle = $(".alm-filter--toggle");
        // var filterInner = $(".alm-filter--inner");

        // $(document).on("click", function () {
        //     $(filterInner).each(function () {
        //         filterInner.hide();
        //     });

        //     $(filterToggle).attr("aria-expanded", "false");
        //     $(filterInner).attr("aria-hidden", "true");
        // });


        // $(filterToggle).each(function () {
        //     $(filterToggle).on("click", function (event) {
        //         event.stopPropagation();
        //     });
        // });



        // $(filterInner).each(function () {
        //     $(filterInner).on("click", function (event) {
        //         event.stopPropagation();
        //     });
        // });

    };

    // Have filters expanded on hover - Kept it just in case

    // var filterTitleGeography = $( "#alm-filter-geography-title" );
    // var filterTitleYear = $( "#alm-filter-year_portfolio-title" );
    // var filterTitleSector = $( "#alm-filter-sector-title" );
    // var filterTitleFund = $( "#alm-filter-fund-title" );
    // var filterTitleType = $( "#alm-filter-type_portfolio-title" );

    // var filterToggleGeography = $( "#alm-filter-geography-inner" );
    // var filterToggleYear = $( "#alm-filter-year_portfolio-inner" );
    // var filterToggleSector = $( "#alm-filter-sector-inner" );
    // var filterToggleFund = $( "#alm-filter-fund-inner" );
    // var filterToggleType = $( "#alm-filter-type_portfolio-inner" );

    // var innerChildrenGeography = filterToggleGeography.children();
    // var innerChildrenYear = filterToggleYear.children();
    // var innerChildrenSector = filterToggleSector.children();
    // var innerChildrenFund = filterToggleFund.children();
    // var innerChildrenType = filterToggleType.children();

    // function expandCheckboxGeography() {
    //     filterToggleGeography.css("display", "block");
    // }
    // function collapseCheckboxGeography() {
    //     filterToggleGeography.css("display", "none");
    // }
    // function expandCheckboxYear() {
    //     filterToggleYear.css("display", "block");
    // }
    // function collapseCheckboxYear() {
    //     filterToggleYear.css("display", "none");
    // }

    // function expandCheckboxSector() {
    //     filterToggleSector.css("display", "block");
    // }
    // function collapseCheckboxSector() {
    //     filterToggleSector.css("display", "none");
    // }
    // function expandCheckboxFund() {
    //     filterToggleFund.css("display", "block");
    // }
    // function collapseCheckboxFund() {
    //     filterToggleFund.css("display", "none");
    // }
    // function expandCheckboxType() {
    //     filterToggleType.css("display", "block");
    // }
    // function collapseCheckboxType() {
    //     filterToggleType.css("display", "none");
    // }

    // if (filterToggleGeography.attr('aria-hidden') == 'true') {
    //     filterTitleGeography.on("mouseover", expandCheckboxGeography);
    //     innerChildrenGeography.on("mouseover", expandCheckboxGeography);
    //     filterTitleGeography.on("mouseout", collapseCheckboxGeography);
    //     innerChildrenGeography.on("mouseout", collapseCheckboxGeography);
    // }
    // if (filterToggleYear.attr('aria-hidden') == 'true') {
    //     filterTitleYear.on("mouseover", expandCheckboxYear);
    //     innerChildrenYear.on("mouseover", expandCheckboxYear);
    //     filterTitleYear.on("mouseout", collapseCheckboxYear);
    //     innerChildrenYear.on("mouseout", collapseCheckboxYear);
    // }



    // if (filterToggleSector.attr('aria-hidden') == 'true') {
    //     filterTitleSector.on("mouseover", expandCheckboxSector);
    //     innerChildrenSector.on("mouseover", expandCheckboxSector);
    //     filterTitleSector.on("mouseout", collapseCheckboxSector);
    //     innerChildrenSector.on("mouseout", collapseCheckboxSector);
    // }
    // if (filterToggleFund.attr('aria-hidden') == 'true') {
    //     filterTitleFund.on("mouseover", expandCheckboxFund);
    //     innerChildrenFund.on("mouseover", expandCheckboxFund);
    //     filterTitleFund.on("mouseout", collapseCheckboxFund);
    //     innerChildrenFund.on("mouseout", collapseCheckboxFund);
    // }
    // if (filterToggleType.attr('aria-hidden') == 'true') {
    //     filterTitleType.on("mouseover", expandCheckboxType);
    //     innerChildrenType.on("mouseover", expandCheckboxType);
    //     filterTitleType.on("mouseout", collapseCheckboxType);
    //     innerChildrenType.on("mouseout", collapseCheckboxType);
    // }

});

var acc = document.getElementsByClassName("filter-accordion");

var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active-filter");
        var panel = this.nextElementSibling;
        panel.classList.toggle("active-panel");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}


// Filters select count 
window.almOnChange = function (almSelect) {
    var almFilters = document.querySelectorAll('.portfolio-list .alm-filter--taxonomy');

    if(almFilters) {
        almFilters.forEach((almFilter, index) => {
            var almLinks = almFilter.querySelectorAll('.alm-filter--link.active');
            var almLinksNumber = almLinks.length;
            // console.log(almLinksNumber);
    
            var almTitle = almFilter.querySelector('.alm-filter--toggle');
    
            if (almLinksNumber > 0) {
                almTitle.innerHTML = 'Selected (' + almLinksNumber + ')' 
            } else if (almLinksNumber == 0) {
                almTitle.innerHTML = '--Select--' 
            }
        })
    }
   
}





